const POLL_INTERVAL_MS = 25000;
const MAX_VISIBLE_BANNERS = 3;
const BANNER_TTL_MS = 7000;

const moduleMeta = {
  kanban: { icon: "view_kanban", color: "#0060FE", label: "Канбан" },
  it_support: { icon: "support_agent", color: "#7C3AED", label: "IT-поддержка" },
  system: { icon: "campaign", color: "#6B7280", label: "Система" },
};

// Старые записи упоминаний писались с модулем kanban_v2.
const moduleAliases = { kanban_v2: "kanban" };

const MODULE_FILTERS = [
  { value: null, label: "Все модули" },
  ...Object.entries(moduleMeta).map(([value, meta]) => ({ value, label: meta.label })),
];

function getModuleMeta(sourceModule) {
  const key = moduleAliases[sourceModule] || sourceModule;
  return moduleMeta[key] || { icon: "notifications", color: "#6B7280", label: "Уведомление" };
}

// created_at приходит без часового пояса (время сервера) — разбираем как локальное.
function parseDate(value) {
  if (!value) return null;
  const date = new Date(String(value).replace(" ", "T"));
  return Number.isNaN(date.getTime()) ? null : date;
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

const pad = (n) => String(n).padStart(2, "0");
const DAY_MS = 24 * 60 * 60 * 1000;

function formatTime(date) {
  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

function formatRelative(value, fallback = "") {
  const date = parseDate(value);
  if (!date) return fallback;
  const diffMin = Math.floor((Date.now() - date.getTime()) / 60000);
  if (diffMin < 1) return "только что";
  if (diffMin < 60) return `${diffMin} мин назад`;
  const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / DAY_MS);
  if (days === 0) return `сегодня в ${formatTime(date)}`;
  if (days === 1) return `вчера в ${formatTime(date)}`;
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} в ${formatTime(date)}`;
}

const MONTHS = [
  "января", "февраля", "марта", "апреля", "мая", "июня",
  "июля", "августа", "сентября", "октября", "ноября", "декабря",
];

function dayLabel(value) {
  const date = parseDate(value);
  if (!date) return "Ранее";
  const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / DAY_MS);
  if (days === 0) return "Сегодня";
  if (days === 1) return "Вчера";
  const year = date.getFullYear() === new Date().getFullYear() ? "" : ` ${date.getFullYear()}`;
  return `${date.getDate()} ${MONTHS[date.getMonth()]}${year}`;
}

export {
  BANNER_TTL_MS,
  MAX_VISIBLE_BANNERS,
  MODULE_FILTERS,
  POLL_INTERVAL_MS,
  dayLabel,
  formatRelative,
  getModuleMeta,
};
